/**
 * Spin.jsx
 *
 * @Author: apple
 * @Date: 2018/1/22 22:48
 */

import React, { isValidElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CSSTransition } from 'react-transition-group';
import Rolling from '../icons/internals/Rolling';

/** Loading */
class Loading extends React.PureComponent {
  static propTypes = {
    /** loading的图标，可自定义 */
    indicator: PropTypes.node,
    /** 控制显示的图标字体大小 */
    prefixCls: PropTypes.string,
    /** 控制显示 */
    show: PropTypes.bool,
    /** 控制显示的文字 */
    loadingText: PropTypes.string,
    /** loading样式类型 */
  };

  static defaultProps = {
    prefixCls: 'ne-loading',
    indicator: <Rolling size="large" />,
    show: false,
    loadingText: '加载中...',
  };

  constructor(props, context) {
    super(props, context);
    this.duration = 300;
  }

  render() {
    const { prefixCls, children, loadingText, show, className, style, indicator } = this.props;

    return (
      <div
        className={classNames(
          prefixCls,
          {
            [`${prefixCls}-show`]: show,
          },
          className,
        )}
        style={style}>
        <CSSTransition
          in={show}
          timeout={this.duration}
          classNames={`${prefixCls}-mask`}
          appear
          mountOnEnter
          unmountOnExit>
          <div className={`${prefixCls}-mask`}>
            <div className={`${prefixCls}-backdrop`} />
            {isValidElement(indicator)
              ? React.cloneElement(indicator, {
                  className: classNames(`${prefixCls}-indicator`, indicator.props.className),
                })
              : null}
            <span className={`${prefixCls}-text`}>{loadingText}</span>
          </div>
        </CSSTransition>
        {React.Children.map(children, child =>
          isValidElement(child)
            ? React.cloneElement(child, {
                className: classNames(`${prefixCls}-container`, child.props.className),
              })
            : null,
        )}
      </div>
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/loading/Loading.jsx